import { render, staticRenderFns } from "./proposalLine.vue?vue&type=template&id=fc09f768&scoped=true&lang=pug"
import script from "./proposalLine.vue?vue&type=script&lang=js"
export * from "./proposalLine.vue?vue&type=script&lang=js"
import style0 from "./proposalLine.vue?vue&type=style&index=0&id=fc09f768&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc09f768",
  null
  
)

export default component.exports